// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';

const THUMBNAIL_CONFIG = 't_pdp_thumb_d,f_auto';
const imgConfig = [THUMBNAIL_CONFIG, THUMBNAIL_CONFIG, THUMBNAIL_CONFIG];

export default function ImageComp({
  imgData,
  index,
  itemBrand,
  quantityToShow,
  wrappedItem,
  itemsHidden,
  disableVideoRender,
}) {
  return (
    <>
      <DamImage
        imgConfigs={imgConfig}
        imgData={imgData}
        isProductImage
        data-locator="order_item_image"
        key={index.toString()}
        itemBrand={itemBrand}
        disableVideoRender={disableVideoRender}
      />
      {quantityToShow && quantityToShow > 1 ? (
        <span className="item-quantity">{quantityToShow}</span>
      ) : null}
      {wrappedItem && itemsHidden ? (
        <span className="hidden-items">{`+${itemsHidden + 1}`}</span>
      ) : null}
    </>
  );
}
